import {usdc, usdg, usdp, cash} from '@sail/icons/react/BrandIcon';
import type {OpenapiCryptocurrencyPayinsResourceSupportedCurrencyAssetCodeEnum} from '@stripe-internal/data-v1/schema/types';
import {absurd} from 'src/utils/absurd';

export const getCurrencyIcon = (
  assetCode: OpenapiCryptocurrencyPayinsResourceSupportedCurrencyAssetCodeEnum,
) => {
  switch (assetCode) {
    case 'usdc':
      return usdc;
    case 'usdp':
      return usdp;
    case 'usdg':
      return usdg;
    case 'cash':
      return cash;
    case 'usdt':
      return usdc;
    default:
      return absurd(assetCode);
  }
};
